<div>
    <a (click)="exitScreen()" style="cursor: pointer"><i-tabler name="x" style="color: #666; font-size: 32px; position: absolute; right: 10px; top: 10px"></i-tabler></a>
    <div style="display: flex; padding: 20px;">
        <img src="assets/images/logos/clu-dark-logo.svg" alt="logo" style="width: 130px; margin: auto;">
    </div>
    <div style="font-weight: 600;font-size: 28px;margin-bottom: 10px;">Cauris Linkup</div>
    <div style="font-weight: 600;">Validation en deux étapes</div>
    <div style="font-weight: 600;margin-bottom: 20px;">Veuillez saisir le code généré par votre application de génération de mot de passes à usage unique</div>
    <form (ngSubmit)="submit()">
        <div>
            <div class="row">
                <div class="col-lg-12">
                    <mat-form-field appearance="outline" class="w-100" style="margin-top: 20px">
                        <mat-label>Saisir le code généré ci-dessous</mat-label>
                        <input matInput type="text" [formControl]="codeMfaFormControl" [readonly]="loading" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="error-container" style="width: 100%;" *ngIf="!!errorText">{{ errorText }}</div>
        <div class="d-flex w-100" style="padding-top: 6px;">
            <button mat-flat-button color="ccdark" type="submit" [disabled]="codeMfaFormControl.invalid || loading" style="font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;">
                <ng-container *ngIf="loading"><mat-spinner diameter="25"></mat-spinner></ng-container>
                <ng-container *ngIf="!loading">{{ "VALIDER" | translate }} </ng-container>
            </button>
        </div>
    </form>
</div>